<template>
    <div class="DatePickermain">
        <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
                <v-text-field :readonly="true" :disabled='currentField.disabled' :placeholder="`${currentField.isPlaceholderVisible ? currentField.placeholder : ''}`"  v-model="date" :label="`${currentField.label}`"  v-bind="attrs" v-on="on" :class="[currentField.required?required_class:currentField.clearable?read_only:others]"></v-text-field>
            </template>
            <v-date-picker :class="[currentField.required?required_class:currentField.clearable?read_only:others]" :readonly="currentField.clearable"
  color="primary"  :disabled='currentField.disabled' v-model="date" @input="menu = false"  :min="min"
  :max="max"></v-date-picker>
        </v-menu>
    
    </div>
    </template>
    

<script>
export default {
    name: "DatePicker",
    props: ["currentField"],
    data() {
        return {
            date: "",
            menu: false,
            required_class:"required",
            others:"others",
             read_only:"readonly",
             min:"",
             max:""
             
        };
    },
    watch:{
        "currentField.datelimitdata"(){
            if(this.currentField.datelimitdata !== null && this.currentField.datelimit == true){
                if(this.currentField.datelimitdata.value == "today"){
                    this.min=this.currenttime("", { increase: 0, mode: "today" })
                    this.max=""
                }
                if(this.currentField.datelimitdata.value == "weak"){
                    this.min=this.currenttime("", { increase: 0, mode: "firstDayOfWeek" })
                    this.max=this.currenttime("", { increase: 0, mode: "lastDayOfWeek" })
                }
                if(this.currentField.datelimitdata.value == "yesterday"){
                    this.min=this.currenttime("", { increase: 0, mode: "yesterday" })
                    this.max=""
                }
                if(this.currentField.datelimitdata.value == "month"){
                    this.min=this.currenttime("", {  mode: "firstDayOfMonth" })
                    this.max=this.currenttime("", {  mode: "lastDayOfMonth" })
                }
                if(this.currentField.datelimitdata.value == "year"){
                    this.min=this.currenttime("", {  mode: "firstDayOfYear" })
                    this.max=this.currenttime("", {  mode: "lastDayOfYear" })
                }
                if(this.currentField.datelimitdata.value == "date_betwn"){
                    this.min=this.currenttime(this.currentField.datelimitdata.limit[0])
                    this.max=this.currenttime(this.currentField.datelimitdata.limit[1])
                }
                if(this.currentField.datelimitdata.value == "curr_date_after"){
                    this.min=this.currenttime("", { increase: 0, mode: "today" })
                    this.max=this.currenttime("", { increase: this.currentField.datelimitdata.limit, mode: "today" })
                }
                if(this.currentField.datelimitdata.value == "curr_date_before"){
                    this.min=this.currenttime("", { increase: -this.currentField.datelimitdata.limit, mode: "today" })
                    this.max=this.currenttime("", { increase: 0, mode: "today" })
                }
                if(this.currentField.datelimitdata.value == "date_before"){
                    this.min=this.currenttime("", { increase: -this.currentField.datelimitdata.limit, mode: "today" })
                    this.max=""
                }
                if(this.currentField.datelimitdata.value == "date_after"){
                    this.min=this.currenttime("", { increase: this.currentField.datelimitdata.limit, mode: "today" })
                    this.max=""
                }
            }
        }
    },
    mounted(){
        if(this.currentField.datelimitdata !== null && this.currentField.datelimitdata !== "" && this.currentField.datelimit == true){
                if(this.currentField.datelimitdata.value == "today"){
                    this.min=this.currenttime("", { increase: 0, mode: "today" })
                    this.max=""
                }
                if(this.currentField.datelimitdata.value == "weak"){
                    this.min=this.currenttime("", { increase: 0, mode: "firstDayOfWeek" })
                    this.max=this.currenttime("", { increase: 0, mode: "lastDayOfWeek" })
                }
                if(this.currentField.datelimitdata.value == "yesterday"){
                    this.min=this.currenttime("", { increase: 0, mode: "yesterday" })
                    this.max=""
                }
                if(this.currentField.datelimitdata.value == "month"){
                    this.min=this.currenttime("", {  mode: "firstDayOfMonth" })
                    this.max=this.currenttime("", {  mode: "lastDayOfMonth" })
                }
                if(this.currentField.datelimitdata.value == "year"){
                    this.min=this.currenttime("", {  mode: "firstDayOfYear" })
                    this.max=this.currenttime("", {  mode: "lastDayOfYear" })
                }
                if(this.currentField.datelimitdata.value == "date_betwn"){
                    this.min=this.currenttime(this.currentField.datelimitdata.limit[0])
                    this.max=this.currenttime(this.currentField.datelimitdata.limit[1])
                }
                if(this.currentField.datelimitdata.value == "curr_date_after"){
                    this.min=this.currenttime("", { increase: 0, mode: "today" })
                    this.max=this.currenttime("", { increase: this.currentField.datelimitdata.limit, mode: "today" })
                }
                if(this.currentField.datelimitdata.value == "curr_date_before"){
                    this.min=this.currenttime("", { increase: -this.currentField.datelimitdata.limit, mode: "today" })
                    this.max=this.currenttime("", { increase: 0, mode: "today" })
                }
                if(this.currentField.datelimitdata.value == "date_before"){
                    this.min=this.currenttime("", { increase: -this.currentField.datelimitdata.limit, mode: "today" })
                    this.max=""
                }
                if(this.currentField.datelimitdata.value == "date_after"){
                    this.min=this.currenttime("", { increase: this.currentField.datelimitdata.limit, mode: "today" })
                    this.max=""
                }
        }
    },
    methods: {
        currenttime(data = "", options = { increase: 0, mode: "today" }) {
            // Use today's date if input is empty or invalid
            const today = data ? new Date(data) : new Date();

            // Adjust the date by the increase or decrease in days
            today.setDate(today.getDate() + options.increase);

            // Extract year, month, and day
            const yyyy = today.getFullYear();
            let mm = today.getMonth() + 1; // Months are 0-based
            let dd = today.getDate();

            // Add leading zeros for consistency
            if (mm < 10) mm = "0" + mm;
            if (dd < 10) dd = "0" + dd;

            // Determine output based on the mode
            switch (options.mode) {
                case "firstDayOfWeek": {
                    const day = today.getDay();
                    const diff = day === 0 ? -6 : 1 - day; // Adjust to Monday (start of the week)
                    today.setDate(today.getDate() + diff);
                    break;
                }
                case "lastDayOfWeek": {
                    const day = today.getDay();
                    const diff = day === 0 ? 0 : 7 - day; // Adjust to Sunday (end of the week)
                    today.setDate(today.getDate() + diff);
                    break;
                }
                case "yesterday": {
                    today.setDate(today.getDate() - 1); // Move back 1 day
                    break;
                }
                case "firstDayOfMonth": {
                    today.setDate(1); // Set to the first day of the current month
                    break;
                }
                case "lastDayOfMonth": {
                    today.setMonth(today.getMonth() + 1); // Move to the next month
                    today.setDate(0); // Set to the last day of the previous month
                    break;
                }
                case "firstDayOfYear": {
                    today.setMonth(0); // Set to January
                    today.setDate(1); // Set to the 1st day
                    break;
                }
                case "lastDayOfYear": {
                    today.setMonth(11); // Set to December
                    today.setDate(31); // Set to the last day
                    break;
                }
                case "today":
                default:
                    break; // Keep the adjusted "today" value
            }


            // Format the output
            const formattedDate = `${yyyy}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
            return formattedDate;
        }
    },
    computed: {
        attributesBinding() {
            var attr = {};
            attr["id"] = this.currentField.model;
            attr.disabled = this.currentField.disabled;
            return attr;
        },
    },
};
</script>

<style>
.DatePickermain {
    height: 85px;
    padding: 10px;
}
.required:after {
    content:" *";
    color: rgb(255, 0, 0);
    font-weight: 600;
    padding-left:2px ;
  }

  .readonly:after {
    content:" *";
    color: rgb(4, 0, 255);
    font-weight: 600;
    padding-left:2px ;
  }

  .others:after{
    content:"";
    font-weight: 600;
    padding-left:2px ;
  }
</style>
